export const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const upperCaseRegex = /[A-Z]+/;
export const lowerCaseRegex = /[a-z]+/;
export const specialCharRegex = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;
export const numberRegex = /[0-9]+/;
export const intRegex = /^[0-9]*$/;
export const decimalNumberRegex = /^\d*\.?\d*$/;